import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Echo from 'laravel-echo';
import User from 'src/store/models/User';

require('pusher-js');

export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var connect;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            connect = function connect() {
              var _process$env$REVERB_S;

              context.Vue.prototype.$echo = new Echo({
                broadcaster: 'reverb',
                namespace: 'App\\Events',
                key: process.env.REVERB_APP_KEY,
                csrfToken: null,
                authEndpoint: process.env.SERVER_URL + '/broadcasting/auth',
                wsHost: process.env.REVERB_HOST,
                wsPort: process.env.REVERB_PORT,
                forceTLS: ((_process$env$REVERB_S = process.env.REVERB_SCHEME) !== null && _process$env$REVERB_S !== void 0 ? _process$env$REVERB_S : 'https') === 'https',
                disableStats: true,
                enabledTransports: ['ws', 'wss'],
                // wss
                auth: {
                  headers: {
                    Authorization: 'Bearer ' + User.accessToken()
                  }
                }
              });
            };

            connect();

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();